import { Button } from '@progress/kendo-react-buttons';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { Loader } from '@progress/kendo-react-indicators';
import { Label } from '@progress/kendo-react-labels';
import 'scss/_adsproduct.scss';
import Header from 'commons/card/Header';
import {
  FormDropDownList,
  FormNumericTextBox,
  FormRadioGroup,
  FormSingleCheckbox,
} from 'commons/forms/form';
import { dateQueryFormatReverse } from 'commons/models/dates';
import {
  TreeView,
  processTreeViewItems,
  handleTreeViewCheckChange,
} from '@progress/kendo-react-treeview';
import { required } from 'commons/forms/validators';
import React, { useRef, useState, useEffect } from 'react';
import Blockquote from 'commons/status/Blockquote';
import { Blogue, Infolettre, Journal, SiteWeb } from "../../gant/constantes/medias";
import { useAddProduitAnnonceMutation, useGetDepartementsQuery, useGetDiffuseursQuery, useGetDivisionsQuery, useGetMediasQuery, useLazyGetCampagneReqQuery, useLazyGetProjectQuery } from '../../../redux/api/cache';

export default function AdsProduct() {
  const [project, setProject] = useState(undefined);
  const [datesVigueur, setDatesVigueur] = useState(undefined);
  const [media, setMedia] = useState("");
  const [base64Pdf, setBase64Pdf] = useState(undefined);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const isInfolettre = media === Infolettre;
  const isBlogue = media === Blogue;
  const isJournal = media === Journal;
  const isSiteWeb = media === SiteWeb;
  const [tree, setTree] = useState([]);
  const [check, setCheck] = useState([]);
  const [expand, setExpand] = useState({
    ids: ['Item2'],
    idField: 'dept_cd',
  });

  const linkRef = useRef(null);

  const { data: diffuseur } = useGetDiffuseursQuery(media, { skip: !media });
  const { data: medias } = useGetMediasQuery();
  const { data: divisions } = useGetDivisionsQuery();
  const { data: departements } = useGetDepartementsQuery({ aveccd: "", div: -1 });
  const [getProject] = useLazyGetProjectQuery();
  const [getCampagneReq, { isLoading }] = useLazyGetCampagneReqQuery();
  const [addProduitAnnonce] = useAddProduitAnnonceMutation();

  const getListDivisions = () => {
    const ListDepart = [];
    const ListDivision = [];

    if (departements && departements.data && divisions && divisions.data) {
      departements.data.forEach((elem) => {
        let tempDepart = {
          text: elem.dept_nom,
          dept_cd: elem.dept_cd,
          div_num: elem.div_num,
        };

        ListDepart.push(tempDepart);
      });

      divisions.data.forEach((elem) => {
        const items = ListDepart.filter((departement) => departement.div_num === elem.div_num);

        if (items?.length > 0) {
          let tempDiv = {
            text: elem.div_nom,
            div_num: elem.div_num,
            items: items,
          };

          ListDivision.push(tempDiv);
        }
      });
    }

    return ListDivision;
  };

  useEffect(() => {
    setTree(getListDivisions());
  }, [divisions, departements]);

  const submit = async (json) => {
    setLoadingPdf(true);
    setBase64Pdf(undefined);
    let result = await addProduitAnnonce(json).unwrap();
    if (result) {
      setBase64Pdf(`data:application/pdf;base64,${result}`);
    }
    setLoadingPdf(false);
  };

  const handleSubmit = async (dataItem) => {
    let post = {};
    post['departements'] = [];
    post['dates'] = [];
    post['diff_cd'] = diffuseur.data?.find(d => d.diff_nom === dataItem.Diffuseur)?.diff_cd;
    post['media_cd'] = dataItem.media;
    post['Projet'] = dataItem.Projet;
    post['Tri'] = dataItem.Tri;
    post['camp_seq'] = project?.camp_seq;

    for (let val in dataItem) {
      if (val.split('-').length === 3) {
        if (dataItem[val]) {
          post['dates'].push(val);
        }
      }
    }

    if (check.length !== 0) {
      check.forEach((elem) => {
        if (elem.split('_').length - 1 === 1) {
          let tempArray = elem.split('_');
          post['departements'].push(
            tree[tempArray[0]].items[tempArray[1]].dept_cd
          );
        }
      });
    }

    submit(post);
  };

  const getDates = async (camp_num, media) => {
    setTree(getListDivisions());

    setDatesVigueur([]);
    setBase64Pdf(undefined);
    setProject(undefined);
    let project = await getProject({ camp_num }).unwrap();
    if (project.success && project.data.length === 1) {
      setProject(project.data[0]);
      let campagneReq = await getCampagneReq({ seq: project.data[0].camp_seq, media }).unwrap();
      if (campagneReq.success) {
        setDatesVigueur(campagneReq.data.map((x) => x.campr_date));
      }
    }
  };
  const initialValues = () => {
    let init = {};
    if (divisions?.data !== undefined) {
      [...new Set(datesVigueur)].forEach((item) => {
        init[item] = true;
      });
      divisions?.data?.forEach((item) => {
        init[item.div_nom] = true;
      });
      init['Tri'] = 'Par date';
      init['Projet'] = 'Complétés';
    }
    return init;
  };

  const onExpandChange = (event) => {
    let ids = expand.ids.slice();
    const index = ids.indexOf(event.item.text);
    index === -1 ? ids.push(event.item.text) : ids.splice(index, 1);
    setExpand({
      ids,
      idField: 'text',
    });
  };

  const checkAll = () => {
    let temp = [];
    for (let i = 0; i < tree.length; i++) {
      temp.push(i.toString());
      for (let j = 0; j < tree[i].items.length; j++) {
        temp.push(i.toString() + '_' + j.toString());
      }
    }

    setCheck(temp);
  };

  const uncheckAll = () => {
    setCheck([]);
  };

  const onCheckChange = (event) => {
    const settings = {
      singleMode: false,
      checkChildren: true,
      checkParents: false,
    };
    setCheck(handleTreeViewCheckChange(event, check, tree, settings));
  };

  const mediaValidator = (e) => required(e, 'Média');
  const numeroCampagneValidator = (e) => required(e, `Numéro de campagne`);
  const diffuseurValidator = (e) => required(e, "Diffuseur");

  return Object.keys(initialValues()).length > 0 ? (
    <div>
      <Header title={'Création de rapports - produits et annonces'}></Header>
      <Form
        initialValues={initialValues()}
        onSubmit={handleSubmit}
        render={(formRenderProps) => (
          <FormElement>
            <fieldset
              className={'k-form-fieldset'}
              style={{ marginTop: '15px' }}
            >
              <div className='row'>
                <div className='col-md-2'>
                  <Field
                    id={'media'}
                    name={'media'}
                    label={'Média'}
                    data={medias?.data?.map((item) => item.media_cd)}
                    component={FormDropDownList}
                    validator={mediaValidator}
                    onChange={async (event) => {
                      setMedia(event.value);
                      let campagne = formRenderProps.valueGetter('campagne');
                      await getDates(campagne, event.value);
                    }}
                  />
                  <Field
                    id={'camp_seq'}
                    name={'campagne'}
                    label={`Campagne`}
                    onChange={async (number) => {
                      let media = formRenderProps.valueGetter('media');
                      await getDates(number.value, media);
                    }}
                    format={'n0'}
                    component={FormNumericTextBox}
                    validator={numeroCampagneValidator}
                  />

                  {(!isInfolettre && !isBlogue && !isSiteWeb) && (
                    <Field
                      id={'diff'}
                      name={'Diffuseur'}
                      label={`Diffuseur`}
                      component={FormDropDownList}
                      data={diffuseur?.data?.map((item) => item.diff_nom)}
                      validator={diffuseurValidator}
                    />
                  )}
                </div>
                <div className='col-md-1'>
                  <Field
                    id={'complete'}
                    name={'Projet'}
                    label={'Projet'}
                    component={FormRadioGroup}
                    data={[
                      { label: 'Complétés', value: 'Complétés' },
                      { label: 'Tous', value: 'Tous' },
                    ]}
                  />
                </div>
                {!isJournal && (
                  <div className='col-md-1'>
                    <Field
                      id={'tri'}
                      name={'Tri'}
                      label={'Tri'}
                      component={FormRadioGroup}
                      data={[
                        { label: 'Par date', value: 'Par date' },
                        { label: 'Par modif', value: 'Par modif' },
                      ]}
                    />
                  </div>
                )}
                <div className='col-md-8'>
                  {project !== undefined && (
                    <div style={{ width: '50%', marginLeft: '15px' }}>
                      <legend
                        style={{
                          padding: '5px',
                          color: '#a5a5a5',
                          fontWeight: 'bold',
                        }}
                        className={'k-form-legend'}
                      >
                        {project?.camp_descr}
                      </legend>
                      <div className='row' style={{ marginBottom: '10px' }}>
                        <div className='col-md-4'>
                          <span
                            style={{ fontWeight: 'bold', color: '#a5a5a5' }}
                          >
                            Type :
                          </span>
                        </div>
                        <div className='col-md-8'>
                          <span>{project?.camptyp_cd}</span>
                        </div>
                      </div>
                      <div className='row' style={{ marginBottom: '10px' }}>
                        <div className='col-md-4'>
                          <span
                            style={{ fontWeight: 'bold', color: '#a5a5a5' }}
                          >
                            Date de début :
                          </span>
                        </div>
                        <div className='col-md-8'>
                          <span>
                            {dateQueryFormatReverse(project?.camp_dt_deb)}
                          </span>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-4'>
                          <span
                            style={{ fontWeight: 'bold', color: '#a5a5a5' }}
                          >
                            Groupe :
                          </span>
                        </div>
                        <div className='col-md-6'>
                          <span>{project?.maggrp_cd}</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='row' style={{ marginTop: '15px' }}>
                <div className='col-md-4' style={{ marginRight: '30px' }}>
                  <Label style={{ fontWeight: 'bold', color: '#a5a5a5' }}>
                    {'Divisions'}
                  </Label>
                  <Blockquote icon="information" type="info">
                    <b style={{ paddingLeft: '10px' }}>Vous devez choisir au moins une division</b>
                  </Blockquote>
                  {!isLoading && (
                    <TreeView
                      data={processTreeViewItems(tree, {
                        check: check,
                        expand: expand,
                      })}
                      expandIcons={true}
                      onExpandChange={onExpandChange}
                      aria-multiselectable={true}
                      checkboxes={true}
                      onCheckChange={onCheckChange}
                      className='custom-treeview'
                    />
                  )}
                  {isLoading && <Loader size='medium' type={'pulsing'} />}
                  <Button
                    type='button'
                    className='blueButton'
                    onClick={check.length === 0 ? checkAll : uncheckAll}
                  >
                    {check.length === 0
                      ? 'Tout séléctionner'
                      : 'Tout désélectionner'}
                  </Button>
                </div>
                <div className='co-md-4' style={{ marginTop: '3vh' }}>
                  <Label style={{ fontWeight: 'bold', color: '#a5a5a5' }}>
                    {'Date en vigueur'}
                  </Label>
                  {!isLoading &&
                    [...new Set(datesVigueur)]
                      .sort((a, b) => new Date(a) - new Date(b))
                      .map((item) => (
                        <Field
                          key={item}
                          component={FormSingleCheckbox}
                          id={item}
                          name={item}
                          label={dateQueryFormatReverse(item)}
                        />
                      ))}
                  {isLoading && <Loader size='medium' type={'pulsing'} />}
                </div>
                <div
                  style={{
                    width: '45%',
                    marginRight: '5px',
                    marginTop: '1rem',
                  }}
                ></div>
              </div>
              <div className='k-form-buttons'>
                <Button className='blueButton' type={'submit'} disabled={check?.length === 0}>
                  Générer
                </Button>
                {loadingPdf && (
                  <Loader size='small' type={'infinite-spinner'} />
                )}
                {base64Pdf !== undefined ? <a
                  ref={linkRef}
                  download={true}
                  rel='noreferrer'
                  target='_blank'
                  href={base64Pdf}
                >Télécharger</a> : <></>}
              </div>
            </fieldset>
          </FormElement>
        )}
      />
    </div>
  ) : (
    <div>
      <Loader style={{ marginLeft: '50%' }} size='medium' type={'pulsing'} />
    </div>
  );
}
